'use client'

import Button from "../button/Button"
import { ICONS } from "./Icons"
import { emitEvent } from "./EventListener"

export default function GoogleLoginButton(props) {
  
  if (!props.site.api_keys.g_oauth_client_id) return <></>

  return <>
    <Button onPress={e => emitEvent("launch_google_login", { ctx: props.ctx })} theme={'google'} label="Login with Google">
      { ICONS['google'] }
      <span>Continue with Google</span>
    </Button>
  </>
   
}